// Flow types automatically removed

import { Component } from 'react';
import { noop } from './utils.ts';
import styles from './styles/EditPaneImageRenderer.scss';

class EditPaneImageRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageWidth: 0,
            imageHeight: 0,
            initialized: false,
        };
        this.getDimensionProps = this.getDimensionProps.bind(this);
        this.onImgLoad = this.onImgLoad.bind(this);
    }

    getDimensionProps(containerWidth, containerHeight) {
        if (this.state.initialized) {
            let width;
            let height;
            const { rotation } = this.props;
            const { imageWidth, imageHeight } = this.state;
            const imageAspectRatio = imageWidth / imageHeight;
            const ratioWidth = imageWidth / containerWidth;
            const ratioHeight = imageHeight / containerHeight;
            const alignX = Math.abs(1 - ratioWidth) >= Math.abs(1 - ratioHeight);

            if (rotation % 180) {
                if (alignX) {
                    height = containerWidth;
                    width = height * imageAspectRatio;

                    if (width >= containerHeight) {
                        width = containerHeight;
                        height = width / imageAspectRatio;
                    }
                } else {
                    width = containerHeight;
                    height = width / imageAspectRatio;

                    if (height >= containerWidth) {
                        height = containerWidth;
                        width = height * imageAspectRatio;
                    }
                }
            } else if (alignX) {
                width = containerWidth;
                height = width / imageAspectRatio;

                if (height >= containerHeight) {
                    height = containerHeight;
                    width = height * imageAspectRatio;
                }
            } else {
                height = containerHeight;
                width = height * imageAspectRatio;

                if (width >= containerWidth) {
                    width = containerWidth;
                    height = width / imageAspectRatio;
                }
            }

            return {
                width,
                height,
            };
        }

        return {};
    }

    onImgLoad(event) {
        this.setState({
            imageWidth: event.target.naturalWidth,
            imageHeight: event.target.naturalHeight,
            initialized: true,
        });
        this.props.onImgLoad();
    }

    render() {
        const { imageSrc } = this.props; // default height and width to 0 on initial render
        // so that user doesn't see a flash of the oversized image

        const { width: calcWidth = 0, height: calcHeight = 0 } = this.getDimensionProps(
            this.props.containerWidth - 2,
            this.props.containerHeight - 2
        );
        return (
            <img
                data-tn="edit-pane-image"
                className={styles.image}
                src={imageSrc}
                onLoad={this.onImgLoad}
                width={calcWidth}
                height={calcHeight}
                draggable={false}
            />
        );
    }
}

EditPaneImageRenderer.defaultProps = {
    onImgLoad: noop,
};
export { EditPaneImageRenderer };
